import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBookSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconBookSimple"><Path fillRule="evenodd" clipRule="evenodd" d="M6.75 2C5.23122 2 4 3.23122 4 4.75V19.25C4 20.7688 5.23122 22 6.75 22H17.25C18.7688 22 20 20.7688 20 19.25V4.75C20 3.23122 18.7688 2 17.25 2H6.75ZM5.5 19V19.25C5.5 19.9404 6.05964 20.5 6.75 20.5H17.25C17.9404 20.5 18.5 19.9404 18.5 19.25V17.2001C18.125 17.3919 17.7001 17.5 17.25 17.5H7C6.17157 17.5 5.5 18.1716 5.5 19Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBookSimple;
